export const checksums = {
  "blog": "v3.5.0--GgSF_sr0CuYu_0BPJaWkfcsppwUzbuJN3ENKDTVXPZQ",
  "legal": "v3.5.0--vFB8Zg4wzvWes1weDx5AkuzNA_lq9MLwPs1tN8kTPrI"
}
export const checksumsStructure = {
  "blog": "YdwJGugLI71fjvh55vRcmUaaVQJiOCkZrC1sJ7lUKdo",
  "legal": "-hlew0crkrABaan_98O6jHoJRWc2IZFsOvJtBRhF18A"
}

export const tables = {
  "blog": "_content_blog",
  "legal": "_content_legal",
  "info": "_content_info"
}

export default {
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "author": "json",
      "body": "json",
      "date": "date",
      "description": "string",
      "extension": "string",
      "flag": "string",
      "icon": "string",
      "keywords": "json",
      "length": "number",
      "linkedin": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "slug": "string",
      "stem": "string",
      "thumbnail": "string"
    }
  },
  "legal": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "date": "date",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "slug": "string",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}